import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=2969bf4d&scoped=true&"
import script from "./radio.vue?vue&type=script&lang=ts&"
export * from "./radio.vue?vue&type=script&lang=ts&"
import style0 from "./radio.vue?vue&type=style&index=0&id=2969bf4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2969bf4d",
  null
  
)

export default component.exports